import Slider from "./components/slider";
import MobNav from "./components/mob-nav";
import FilterForm from "./components/filter-form";
import FilterComponent from "./components/filter-component";
import PopUp from "./components/pop-up";
import Booking from "./components/booking";
import Accordion from "./components/accordion";
import LoadSvg from "./components/load-svg";
import ExternLink from "./components/link";
import Replace from "./components/replace";
import Header from "./components/header";
import PopUpLink from "./components/pop-up-link";
import OpenCookie from "./components/open-cookie";
import FloatingLabels from "./components/floating-labels";
import Search from "./components/search";
import { Fancybox } from "@fancyapps/ui";
Fancybox.bind("[data-fancybox]", {
  Toolbar: {
    display: {
      right: ["close"],
    },
  },
});

window.swipers = [];
const sliders = document.querySelectorAll("[data-slider]");
if (sliders.length > 0) {
  sliders.forEach((slider) => {
    const type = slider.getAttribute("data-slider");
    window.swipers[type] = new Slider(slider);
  });
}

window.mobNav = new MobNav();
window.filterForm = new FilterForm();
window.filterComponent = new FilterComponent();
window.popUp = new PopUp();
window.booking = new Booking();
window.accordion = new Accordion();
window.loadSvg = new LoadSvg();
window.externLink = new ExternLink();
window.replace = new Replace();
window.header = new Header();
window.popUpLink = new PopUpLink();
window.cookie = new OpenCookie();
window.search = new Search();
// window.floatingLabels = new FloatingLabels();
